import React from 'react';
import './RemovePartnerModal.scss';

interface RemovePartnerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  partnerName: string;
}

const RemovePartnerModal: React.FC<RemovePartnerModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  partnerName
}) => {
  if (!isOpen) return null;

  return (
    <div className="remove-partner-modal-overlay" role="presentation">
      <div
        className="remove-partner-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="remove-partner-modal-title"
      >
        <button
          className="remove-partner-modal__close-button"
          onClick={onClose}
          aria-label="Close remove partner modal"
        >
          ✕
        </button>
        <div className="remove-partner-modal__header">
          <h2 id="remove-partner-modal-title" className="remove-partner-modal__title">
            Are you sure you want to remove {partnerName}?
          </h2>
        </div>
        
        <div className="remove-partner-modal__content">
          <p className="remove-partner-modal__message">
            This action cannot be undone.
          </p>
        </div>
        
        <div className="remove-partner-modal__footer">
          <div className="remove-partner-modal__footer-container">
            <div className="remove-partner-modal__footer-buttons">
              <auro-button
                className="remove-partner-modal__cancel-button"
                onClick={onClose}
                aria-label="Cancel removing partner"
                variant='secondary'
                size='md'
              >
                No, Cancel
              </auro-button>
              <auro-button
                className="remove-partner-modal__remove-button"
                onClick={onConfirm}
                aria-label="Confirm removing partner"
                variant='primary'
                size='md'
              >
                Yes, Remove
              </auro-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemovePartnerModal;